import React from "react";

// Global loading-skeleton primitive. Single source of truth for the shimmer
// visual (the actual animation lives in the `.skeleton-shimmer` class in
// src/App.css) so every page's loading state looks and animates the same way.
//
// Usage:
//   <Skeleton className="h-4 w-24" />                 // rounded (default)
//   <Skeleton className="h-10 w-10" rounded="rounded-full" />
//   <Skeleton.Box h={32} w={32} r={8} />               // numeric px API
//   <Skeleton.Row />                                   // avatar + 2 lines + pill
//   <Skeleton.Rows rows={4} />
//   <Skeleton.Bars rows={5} />                         // label+% / progress-bar rows
//   <Skeleton.Tiles count={3} className="grid-cols-3" />
export default function Skeleton({ className = "", rounded = "rounded", style }) {
  return <div className={`skeleton-shimmer ${rounded} ${className}`} style={style} />;
}

Skeleton.Box = function SkeletonBox({ h = 14, w = "100%", r = 8, className = "" }) {
  return <Skeleton rounded="" className={className} style={{ height: h, width: w, borderRadius: r, flexShrink: 0 }} />;
};

Skeleton.Row = function SkeletonRow() {
  return (
    <div className="flex items-center gap-3 p-2">
      <Skeleton className="w-10 h-10 flex-shrink-0" rounded="rounded-xl" />
      <div className="flex-1 flex flex-col gap-2">
        <Skeleton className="h-[11px] w-[65%]" />
        <Skeleton className="h-[10px] w-[40%]" />
      </div>
      <Skeleton className="h-6 w-20 hidden sm:block" rounded="rounded-full" />
    </div>
  );
};

Skeleton.Rows = function SkeletonRows({ rows = 3 }) {
  return (
    <div className="flex flex-col gap-2">
      {[...Array(rows)].map((_, i) => <Skeleton.Row key={i} />)}
    </div>
  );
};

Skeleton.Bars = function SkeletonBars({ rows = 5 }) {
  return (
    <div className="space-y-3.5">
      {[...Array(rows)].map((_, i) => (
        <div key={i}>
          <div className="flex items-center justify-between mb-1.5">
            <Skeleton className="h-[11px] w-24" />
            <Skeleton className="h-[11px] w-8" />
          </div>
          <Skeleton className="h-[7px] w-full" rounded="rounded-full" />
        </div>
      ))}
    </div>
  );
};

Skeleton.Tiles = function SkeletonTiles({ count = 3, className = "grid-cols-3" }) {
  return (
    <div className={`grid gap-2.5 ${className}`}>
      {[...Array(count)].map((_, i) => (
        <Skeleton key={i} className="h-[74px]" rounded="rounded-xl" />
      ))}
    </div>
  );
};
